import React from 'react';
import { Jumbotron, Row, Col, Container } from 'react-bootstrap';
import bg from 'assets/images/bg.png';
import logo from 'assets/images/logo.png';
import logoemprega from 'assets/images/logoemprega.png';

import styled from 'styled-components';
import { SearchBar } from 'components';

const StyledHeader = styled(Jumbotron)`
  display: flex;
  align-items: center;
  background-image: url(${bg});
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position-y: -100px;
  height: ${props => props.height || '250px'};
  margin-bottom: 0;
`;

const Logo = styled.img`
  height: 60px;
`;

// eslint-disable-next-line react/prop-types
const Header = ({ logosOnly, height }) => {
  return (
    <StyledHeader fluid height={height}>
      <Container>
        <Row className="justify-content-between align-items-center">
          <a href="/">
            <Logo src={logo} />
          </a>
          <a href="/">
            <Logo src={logoemprega} />
          </a>
        </Row>
        {!logosOnly && (
          <Row className="justify-content-center">
            <Col xs={12} md={5}>
              <SearchBar />
            </Col>
          </Row>
        )}
      </Container>
    </StyledHeader>
  );
};

export default Header;
